import { CdkScrollable } from "@angular/cdk/scrolling";
import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from "@angular/material/dialog";
import { BusyIndicatorComponent } from "@tylertech/common-components-module";
import { ForgeButtonModule } from "@tylertech/forge-angular";
import { Errors } from "@tylertech/shared-module";
import { Address } from "@tylertech/tyler-api-types";
import { AddressComponent } from "./address.component";

export interface AddressDialogData
{
    readonly model: Address;
    /**
     *
     * @param address
     * @returns
     * @deprecated - this seems like a really clumsy interface....
     */
    // eslint-disable-next-line @typescript-eslint/method-signature-style
    readonly onSave: (address: Address) => Promise<boolean>;
}

@Component({
    selector: "address-dialog-component",
    templateUrl: "./addressDialog.tmpl.html",
    imports: [
        AddressComponent,
        BusyIndicatorComponent,
        CdkScrollable,
        ForgeButtonModule,
        MatDialogActions,
        MatDialogContent,
    ]
})
export class AddressDialogComponent
{
    private readonly dialogRef = inject<MatDialogRef<AddressDialogComponent>>(MatDialogRef);
    private readonly data = inject<AddressDialogData>(MAT_DIALOG_DATA);

    error: Errors;

    isProcessing: boolean;
    protected savingPromise?: Promise<void>;

    constructor()
    {
        this.error = {};
    }

    get model(): Address { return this.data.model; }
    private get onSave(): (address: Address) => Promise<boolean> { return this.data.onSave; }

    get hasErrors(): boolean
    {
        return Object.keys(this.error)
            .reduce((valid, key) =>
            {
                return valid || this.error[key] === true;
            }, false);
    }

    cancel(): void
    {
        this.dialogRef.close();
    }

    save(): void
    {
        if (!this.onSave)
        {
            return;
        }

        this.isProcessing = true;
        this.savingPromise = this.onSave(this.model)
            .then(
                value =>
                {
                    if (!value)
                    {
                        //TODO Toast
                        // this.SaveError = "A problem occurred while trying to save the address.";
                        return;
                    }

                    this.dialogRef.close();
                },
                _error =>
                {
                    //TODO Toast
                    //error
                }
            )
            .finally(() =>
            {
                this.isProcessing = false;
                this.savingPromise = undefined;
            });
    }
}
